import { Button, Grid, Grow, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getJudges } from './AdminMenusRequests';
import { SmallModal } from '../../CustomModal/SmallModal';
import AddIcon from '@mui/icons-material/Add';
import { AddJudge } from './modal/AddJudge';
import { grey } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import { deleteJudge } from './JudgeMenusRequests';
import { get_rand } from '../../customprocess/CustomProcess';

export const Judge = () =>{
    const [judges,setJudges] = useState([]);
    useEffect(()=>{
        _init();
    },[])
    const _init = async () => {
        const res = await getJudges()
        setJudges(res.data.data)
    }
    const [openAddModal,setOpenAddModal] = useState(false)
    const handleDelete = (item) =>{
        console.log(item)
        Swal.fire({
            icon:'question',
            title:'Confirm deletion?',
            text:'This action cannot be reverted',
            confirmButtonText:'Yes, Confirm deletion!',
            cancelButtonText:'No, Cancel deletion!',
            showCancelButton:true
        }).then(async res=>{
            if(res.isConfirmed){
                const toastId = toast.loading('Deleting Judge')
                const res = await deleteJudge({id:item.id})
                if(res.data.status === 200){
                    setJudges(res.data.data)
                    toast.success(res.data.message,{
                        id:toastId
                    })
                }else{
                    toast.error(res.data.message,{
                        id:toastId
                    })
                }
            }
        })
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography>Judges</Typography>
                <Button variant='outlined' startIcon={<AddIcon/>} onClick={()=>setOpenAddModal(true)}>Add</Button>
            </Grid>
            <Grid item xs={12}>
                <Grow in>
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead sx={{background:grey[100]}}>
                                    <TableRow>
                                        <TableCell>
                                            Username
                                        </TableCell>
                                        <TableCell>
                                            Code
                                        </TableCell>
                                        <TableCell>
                                            Name
                                        </TableCell>
                                        <TableCell>

                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        judges.map((item)=>
                                        <TableRow key={item.id}>
                                            <TableCell>
                                                {item.user}
                                            </TableCell>
                                            <TableCell>
                                                {item.code}
                                            </TableCell>
                                            <TableCell>
                                                {item.name}
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title='Delete'>
                                                <IconButton color='error' className='icon-btn-bordered' onClick={()=>handleDelete(item)}><DeleteIcon/></IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
                <SmallModal open = {openAddModal} close={()=>setOpenAddModal(false)} title='Adding New Judge'>
                    <AddJudge close={()=>setOpenAddModal(false)} setJudges={setJudges} judges = {judges}/>
                </SmallModal>
            </Grid>
        </Grid>
    )
}